import { useEffect, useState } from "react";
import s from '../styles/Avatar.module.css';

export default function Avatar({ userId }) {
  const [avatarData, setAvatarData] = useState("");
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   fetch(`/api/avatar/${userId}`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.image_base64) {
  //         setAvatarData(`data:image/jpeg;base64,${data.image_base64}`);
  //       }
  //     });
  // }, [userId]);
  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const res = await fetch(`/api/avatar/${userId}`);
        const data = await res.json();

        if (data.image_base64) {
          setAvatarData(`data:image/jpeg;base64,${data.image_base64}`);
        }
      } catch (err) {
        console.error("Ошибка загрузки аватара:", err);
      } finally {
        setLoading(false); // ✅ снимаем загрузку в любом случае
      }
    };

    fetchAvatar();
  }, [userId]);

  if (loading){
    return (
        <div className={s.loader_container}>
          <div className={s.spinner}></div>
        </div>
      );
  }

  if (!avatarData) {
    return (
      <img
        src="/default.jpg"
        alt="Аватар"
        style={{
          borderRadius: "50%",
          width: "100%",
          height: "100%",
          objectFit: "cover"
        }}
      />
    );
  }

  return (
    <img
      src={avatarData}
      alt="Аватар"
      style={{
        borderRadius: "50%",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        border: "2px solid white"
      }}
    />
  );
}
